const TakeItEasy = [
	'[Verse 1]',
	"Well, I'm a runnin' down the road, tryin' to loosen my load,",
	"I've got seven women on my mind.",
	'Four that wanna own me, two that wanna stone me,',
	"one says she's a friend of mine.",
	'',
	'[Chorus]',
	'Take it easy, take it ea - sy,',
	"don't let the sound of your own wheels drive you crazy.",
	'',
	'[Verse 2]',
	"Lighten up while you still can, don't even try to understand,",
	'just find a place to make your stand and take it easy.',
	"Well, I'm a standin' on a corner in Winslow, Arizona",
	'and such a fine sight to see:',
	"it's a girl, my Lord, in a flat bed Ford",
	"slowin' down to take a look at me.",
	"Come on, ba - by, don't say may - be.",
	'I gotta know if your sweet love is gonna save me.',
	'We may lose and we may win though we will never be here again.',
	"So open up, I'm climbin' in, so take it easy.",
	'',
	'[Verse 3]',
	"Well, I'm a runnin' down the road, tryin' to loosen my load,",
	'got a world of trouble on my mind.',
	"Lookin' for a lover who won't blow my cover,",
	"she's so hard to find.",
	'',
	'[Chorus]',
	'Take it easy, take it ea - sy,',
	"don't let the sound of your own wheels drive you crazy.",
	'',
	"Come on, ba - by, don't say may - be.",
	'I gotta know if your sweet love is gonna save me.',
	'',
	'[Bridge]',
	'Oooo oo oo oooo oo oo oooo oo oo oooo oo oo',
	'Oooo oo oo ooo oo oo oooo oo oo oooo oo oo',
	'Oooo oo oo ooo oo oo Oh, we got it eeea ea-ea - sy,',
	'.........',
	'We ought to take it eeea ea-ea - sy.',
];

export default TakeItEasy;
